import { HeaderWrapper } from 'layouts';
import type { PublicEventContentObject } from 'models';
import { HeaderAsset, HeaderContent } from 'ui';
import { images } from 'common/utils';
import { useGetEventTagsProperties } from '../hooks';

type P = { eventContentObject: PublicEventContentObject };

const PublicProgramEventHeader = ({ eventContentObject }: P) => {
  const { coverPhoto, endTime, eventType, name, startTime, status } = eventContentObject.event;
  const tags = useGetEventTagsProperties({ endTime, eventType, startTime, status });

  return (
    <HeaderWrapper
      left={
        <HeaderAsset image={{ alt: 'Event cover photo', src: coverPhoto?.url ?? images.default.eventCoverPhoto }} />
      }
      right={<HeaderContent tags={tags} timeInfo={{ dateFrom: startTime, dateTo: endTime }} title={name} />}
    />
  );
};

export default PublicProgramEventHeader;
